module.exports = __webpack_public_path__ + "img/ic-scan-qr.svg";